<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <div slot="header">
                    <h4 class="card-title">Manage Newsletters</h4>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>

                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                        </div>
                        
                        <div>
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                placeholder="Volume"
                                v-model="volume"
                                @change="changeVolume"
                            >
                                <el-option class="select-primary" v-for="item in volumes"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>
                            <fg-input style="width: 200px; display: inline-block; margin-left: 10px;">
                                <el-input type="search"  class="mb-3" style="width: 400px"
                                prefix-icon="el-icon-search"
                                :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                                v-model="searchQuery"
                                aria-controls="datatables"
                                ></el-input>
                            </fg-input>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2" v-for="(letter, index) in queriedData" :key="index">
                        <NewsletterCard :letter="letter" @action-click="actionClick"></NewsletterCard>
                    </div>
                </div>

                <div slot="footer" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                    <div> 
                        <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

    </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { Pagination as NPagination, NewsletterCard } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        NewsletterCard
    },
    computed: {
        ...mapGetters({
            tableData: 'getNewsletters',
            volumes: 'getVolumes',
            preferences: 'getPreferences',
            authTokens: 'getAuthTokens',
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "volume", "issue", "date" ],
            tableColumns: [
                {
                    prop: "slug",
                    label: "Slug",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "volume",
                    label: "Volume",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "issue",
                    label: "Issue",
                    minWidth: 150,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "draft",
                    label: "Draft?",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return cellValue ? 'Yes' : 'No'
                    }
                },
                {
                    prop: "date",
                    label: "Date",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        let d = new Date(cellValue)
                        return d.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })
                    }
                },
            ],
            searchedData: [],
            fuseSearch: null,
            volume: null,
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        actionClick(newsletter, action){
            switch(action){
                case 'view':
                    this.$router.push(`/glimpses/newsletters/view/${newsletter._id}`)
                    break;
                case 'edit':
                    this.$router.push(`/glimpses/newsletters/edit/${newsletter._id}`)
                    break;
                case 'delete':
                    swal({
                        title: "Are you sure?",
                        text: `You won't be able to revert this!`,
                        showCancelButton: true,
                        confirmButtonClass: "btn btn-danger btn-fill",
                        cancelButtonClass: "btn btn-default btn-fill",
                        confirmButtonText: "Delete it!",
                        buttonsStyling: false
                    }).
                    then(result => {
                        if (result.value) {
                            this.$store.dispatch('deleteNewsletter', newsletter._id)
                        }
                    });
                    break;
                case 'approve':
                    this.$store.dispatch('approveNewsletter', newsletter)
                    break;
                case 'send':
                    this.$store.dispatch('sendNewsletter', newsletter)
                    break;
            }
        },
        openModal(){
            this.$router.push(`/glimpses/newsletters/compose/${this.volume}`);
        },
        changeVolume(){
            this.$store.dispatch('getNewslettersByVolume', this.volume);
        }
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getNewsletters');
        this.$store.dispatch('getVolumes');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }
</style>

